var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopyLinkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-6 0 25 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.112 9.14l-.801.801c-.62.621-1.631.621-2.252 0a1.595 1.595 0 010-2.252L4.31 5.437a1.593 1.593 0 012.252 0c.194.194.32.428.393.675.06-.034.12-.062.17-.112l1.046-1.046a3.131 3.131 0 00-.483-.643 3.185 3.185 0 00-4.504 0L.933 6.563a3.185 3.185 0 004.504 4.504l1.707-1.706c-.682.1-1.383.032-2.032-.221zM11.067.933a3.186 3.186 0 00-4.504 0L4.856 2.639a3.995 3.995 0 012.032.221l.8-.801A1.594 1.594 0 019.94 4.31L7.69 6.563c-.62.62-1.631.621-2.252 0a1.566 1.566 0 01-.393-.676c-.059.034-.12.063-.17.113L3.827 7.047c.135.227.288.447.484.642a3.184 3.184 0 004.504 0l2.252-2.252a3.186 3.186 0 000-4.504z"
  })));
}

export default SvgCopyLinkIcon;